'use strict';

exports.__esModule = true;
exports.datosLocalesHelper = datosLocalesHelper;

var _jsonwebtoken = require('jsonwebtoken');

var _jsonwebtoken2 = _interopRequireDefault(_jsonwebtoken);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function datosLocalesHelper() {
  var userToken = JSON.parse(localStorage.getItem('tokenSeps'));

  if (userToken) {
    var decodificacion = {};

    var decode = _jsonwebtoken2.default.decode(userToken, {
      complete: true
    });

    decodificacion['tokenSeps'] = decode.payload;
    var sistemaSeps = JSON.parse(localStorage.getItem('sistemaSeps'));

    if (sistemaSeps) {
      decodificacion['sistemaSeps'] = sistemaSeps;
    }

    var orgSeps = JSON.parse(localStorage.getItem('orgSeps'));

    if (orgSeps) {
      decodificacion['orgSeps'] = orgSeps;
    }

    var nsistemasSeps = JSON.parse(localStorage.getItem('nsistemasSeps'));

    if (nsistemasSeps) {
      decodificacion['nsistemasSeps'] = nsistemasSeps;
    }

    var norgSeps = JSON.parse(localStorage.getItem('norgSeps'));

    if (norgSeps) {
      decodificacion['norgSeps'] = norgSeps;
    }

    return decodificacion;
  }

  return null;
}